<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div v-if="modules.length==1">
            <div class="page_block">
                <h3>{{modules[0].name}}
                </h3>
                <a-row>
                    <a-col :span="12">
                        <div class="page_block_content">
                            <div v-html="infos[0][0]"></div>
                            <a-divider />
                            <div style="text-align:right">
                                <a-button-group style="margin:0 0 20px 10px" >
                                    <a-button @click="lockHeader(0,1)" :type="locks.indexOf('0_1')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('0_1')>=0?'取消固定':'固定表头'}}</a-button>
                                    <a-button @click="exportToExcel(0,1)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                                    <a-button @click="copy(0, 1)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                                </a-button-group>
                            </div>
                            <DataTable :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" :datas="datas[0][0]" ref="datatable_0_1" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl"  :show_index="modules[0].show_index" />
                        </div>
                    </a-col>
                    <a-col :span="12">
                        <div class="page_block_content">
                            <div v-html="infos[0][1]"></div>
                            <a-divider />
                            <div style="text-align:right">
                                <a-button-group style="margin:0 0 20px 10px" >
                                    <a-button @click="lockHeader(0,2)" :type="locks.indexOf('0_2')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('0_2')>=0?'取消固定':'固定表头'}}</a-button>
                                    <a-button @click="exportToExcel(0,2)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                                    <a-button @click="copy(0, 2)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                                </a-button-group>
                            </div>
                            <DataTable :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" :datas="datas[0][1]" ref="datatable_0_2" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl" :show_index="modules[0].show_index" />
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div v-if="modules.length>1">
            <div class="page_block">
                <a-tabs v-model="current">
                    <a-tab-pane :tab="m.name" v-for="(m, index) in modules" :key="index">
                        <div class="page_block_content" v-if="current==index">
                            <h3>{{modules[index].name}}
                            </h3>
                            <a-row>
                                <a-col :span="12">
                                    <div class="page_block_content">
                                        <div v-html="infos[index][0]"></div>
                                        <a-divider />
                                        <a-button-group style="float:right; margin:0 0 20px 10px" >
                                            <a-button @click="lockHeader(index,1)" :type="locks.indexOf(`${index}_1`)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(`${index}_1`)>=0?'取消固定':'固定表头'}}</a-button>
                                            <a-button @click="exportToExcel(index,1)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                                            <a-button @click="copy(index,1)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                                        </a-button-group>
                                        <DataTable :liucun="modules[index].liucun" :fields="modules[index].fields" :theads="modules[index].theads" :datas="datas[index][0]" :ref="`datatable_${index}_1`" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl"  :show_index="modules[index].show_index"/>
                                    </div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="page_block_content">
                                        <div v-html="infos[index][1]"></div>
                                        <a-divider />
                                        <a-button-group style="float:right; margin:0 0 20px 10px" >
                                            <a-button @click="lockHeader(index,2)" :type="locks.indexOf(`${index}_2`)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(`${index}_2`)>=0?'取消固定':'固定表头'}}</a-button>
                                            <a-button @click="exportToExcel(index,2)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                                            <a-button @click="copy(index,2)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                                        </a-button-group>
                                        <DataTable :liucun="modules[index].liucun" :fields="modules[index].fields" :theads="modules[index].theads" :datas="datas[index][1]" :ref="`datatable_${index}_2`" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl"  :show_index="modules[index].show_index"/>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.query(this.queryId, params).then((data)=>{
                let datas = [], infos = []
                data.forEach((d)=>{
                    datas.push(d.datas)
                    infos.push(d.infos)
                })
                this.datas = datas
                this.infos = infos
                this.loading = false    
            }).catch((data)=>{
                this.loading = false
            })
        },
    },
    data() {
        return {
            datas:[[[],[]]],
            infos:[["",""]],
            current:0,
        }
    },
}
</script>
